import React, { Component } from 'react';

class SendButton extends Component{
    constructor(props) {
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
        this.state = {clicked: false};
      }
    
    clickHandler = function(e) {
        this.setState({clicked: true});
        this.props.clickHandler(e);
    }

    render(){
        return (
            <div className="send-button">
                {!this.state.clicked && <button onClick = {this.clickHandler} className={"finish-send-button"}>SENDEN >></button>}
                {this.state.clicked && <img src="/ajax-loader.gif" />}
            </div>
        )
    }
}

export default SendButton;


// WEBPACK FOOTER //
// ./src/containers/steps/FinishStep/SendButton.js